module.exports = __webpack_public_path__ + "images/psp/Bicycle/shared-storage.svg";